export const companyData = [
  {
    label: "บริษัท A",
    value: "A",
  },
  {
    label: "บริษัท B",
    value: "B",
  },
  {
    label: "บริษัท C",
    value: "C",
  },
  {
    label: "บริษัท D",
    value: "D",
  },
];
